// Generated by npm run generate-i18n-catalogs. Do not edit directly.

export const catalogIt = {
  "controls": {
    "boot": "Avvia",
    "reset": "Ripristina",
    "copyScreen": "Copia Schermo",
    "copyText": "Copia testo",
    "pasteText": "Incolla Testo",
    "saveState": "Salva Stato",
    "restoreState": "Ripristina Stato",
    "toggleSound": "Attiva/Disattiva Suono",
    "settings": "Impostazioni",
    "debugPanel": "Pannello di Debug",
    "infoPanel": "Pannello informazioni",
    "reportIssue": "Segnala un problema",
    "privacyPolicy": "Informativa sulla privacy"
  },
  "config": {
    "speed": "Velocità",
    "display": "Impostazioni Display",
    "theme": "Tema",
    "openRetroControlPanel": "Pannello di controllo",
    "resetSettings": "Ripristina Tutte le Impostazioni",
    "capsLock": "Blocco Maiuscole",
    "useOpenApple": "Usa il tasto {{modKey}} per Open Apple",
    "useShortcuts": "Usa il tasto {{modKey}} per le scorciatoie tastiera",
    "useArrowKeys": "Usa Frecce come Joystick",
    "scanlines": "Linee di Scansione CRT",
    "ghosting": "Persistenza dei Fosfori",
    "crtDistortion": "Distorsione CRT",
    "joystick": "Configurazione joystick"
  },
  "machine": {
    "slotConfigurator": "Slot di espansione"
  },
  "speed": {
    "snail": "Lumaca (0.1 MHz)",
    "slow": "Lenta (0.5 MHz)",
    "normal": "Velocità Normale (1 MHz)",
    "fast": "Veloce (4 MHz)",
    "warp": "Velocità ridicola"
  },
  "colors": {
    "color": "Colore",
    "nofringe": "Colore (senza frangia)",
    "green": "Verde",
    "amber": "Ambra",
    "white": "Bianco e Nero",
    "inverse": "Bianco e Nero (inverso)"
  },
  "themes": {
    "classic": "Classico",
    "dark": "Scuro",
    "minimal": "Minimale"
  },
  "debug": {
    "helpPanel": "Mostra pannello aiuto",
    "debugPanel": "Mostra pannello debug",
    "expectinPanel": "Mostra pannello Apple exPectin",
    "helpTab": "Aiuto",
    "debugTab": "Debug",
    "breakpoints": "Breakpoint",
    "memory": "Memoria",
    "state": "Stato CPU",
    "registers": "Registri",
    "flags": "Flag",
    "step": "Passo",
    "stepOver": "Passo Oltre",
    "stepInto": "Passo Dentro",
    "stepOut": "Passo Fuori",
    "resume": "Riprendi",
    "pause": "Pausa",
    "loadSymbolTable": "Carica tabella simboli",
    "disassembly": "Disassemblaggio"
  },
  "tour": {
    "welcome": "Benvenuto nell'emulatore Apple2TS!",
    "clickNext": "Per saperne di più, premi il pulsante Avanti.",
    "bootButton": "Clicca qui per avviare l'emulatore.",
    "resetButton": "Clicca qui per ripristinare l'Apple II e riavviare o entrare in BASIC.",
    "diskImages": "Scegli una delle immagini disco installate.",
    "floppyDisks": "Oppure clicca su una delle icone floppy per caricare un'immagine disco.",
    "saveRestore": "Puoi salvare e ripristinare lo stato completo dell'emulatore usando questi pulsanti.",
    "themeButton": "Clicca qui per cambiare il tema dell'interfaccia dell'emulatore.",
    "endTour": "Hai raggiunto la fine del tour. Clicca sul pulsante tour globo per provare uno degli altri tour, o premi Termina per iniziare a usare l'emulatore.",
    "tourSelectorHint": "Fai clic sul pulsante del tour del globo per provare uno degli altri tour o premi Fine per iniziare a utilizzare l'emulatore.",
    "settingsWelcome": "Apple2TS ha un set completo di controlli sia per l'emulatore che per l'Apple II. Per saperne di più, premi il pulsante Avanti.",
    "mainControls": "Qui, puoi avviare e ripristinare l'Apple II, ripristinare e salvare lo stato, copiare lo schermo, o incollare testo nell'emulatore.",
    "snapshot": "In qualsiasi momento, puoi scattare un'istantanea dello stato attuale dell'emulatore, poi tornare indietro nel tempo a uno stato precedente, o avanzare velocemente di nuovo. Puoi anche salvare lo stato dell'emulatore con tutte le istantanee correnti.",
    "pauseButton": "Puoi mettere in pausa l'emulatore in qualsiasi momento, congelando il processore 6502. Questo è utile per mettere in pausa l'azione in un gioco, o entrare nel debugger.",
    "debugButton": "Clicca sul bug per entrare in modalità debug, dove puoi vedere lo stato interno del processore 6502. Clicca di nuovo per tornare alla modalità normale.",
    "configButtons": "La fila inferiore di pulsanti controlla lo stato dell'Apple II, iniziando con la velocità dell'emulatore, il colore dello schermo, e il silenziamento dell'audio.",
    "keyboardButtons": "Se il tasto di blocco maiuscole è attivato, allora tutti i caratteri digitati sono MAIUSCOLI.",
    "altArrowKeys": "Il tasto successivo determina se il tasto {{modKey}} è usato per le scorciatoie tastiera o il tasto Open Apple dell'Apple II. L'ultimo tasto determina se i tasti freccia possono essere usati come joystick dell'Apple II.",
    "clearCookies": "Apple2TS salva automaticamente le impostazioni correnti dell'emulatore come cookie del browser. Premi questo pulsante per ripristinare queste impostazioni ed eliminare i cookie.",
    "debugWelcome": "Apple2TS ha un ricco set di strumenti per analizzare e debuggare codice assembly 6502. Per saperne di più, premi il pulsante Avanti.",
    "debugIcon": "Clicca sull'icona Bug nelle schede Info per visualizzare il pannello Debug.",
    "debugPause": "Premi il pulsante Pausa per mettere in pausa o riprendere l'esecuzione dell'emulatore.",
    "debugControls": "Ora che abbiamo messo in pausa, possiamo attraversare il codice disassemblato usando i pulsanti Passo Oltre, Dentro, e Fuori. Possiamo anche saltare velocemente all'indirizzo corrente del Program Counter (PC).",
    "debugDisassembly": "Qui vediamo il codice disassemblato, con gli indirizzi esadecimali, l'istruzione a tre lettere, e qualsiasi valore o indirizzo. Se muovi il mouse su un valore verde, apparirà un tooltip con il valore corrente. Cliccare su un indirizzo blu scorrerà a quella posizione. Puoi anche cliccare nel margine sinistro per aggiungere o rimuovere breakpoint.",
    "debugInfo": "Nel mezzo abbiamo il Dump Stack e una Mappa Memoria. La Mappa Memoria si aggiorna in tempo reale e ti mostra quali banchi di memoria sono attualmente attivi.",
    "debugMemory": "L'ultima sezione mostra la memoria dell'Apple II. Puoi usare la lista a discesa per esaminare diverse porzioni di memoria. Se passi a una delle pagine HGR, otterrai una vista ingrandita dello schermo ad alta risoluzione, collegata alle posizioni di memoria. Puoi anche cercare valori esadecimali o stringhe ASCII, e salvare la memoria in un file.",
    "back": "Indietro",
    "close": "Chiudi",
    "last": "Termina",
    "next": "Avanti",
    "nextLabelWithProgress": "Avanti (Passaggio {step} di {steps})",
    "skip": "Chiudi",
    "guidedTour": "Tour Guidato",
    "mainLabel": "Tour Guidato: Principale",
    "settingsLabel": "Tour Guidato: Impostazioni",
    "debugLabel": "Tour Guidato: Debug"
  },
  "disk": {
    "drive1": "Unità 1",
    "drive2": "Unità 2",
    "hardDisk": "Disco Rigido",
    "eject": "Espelli Disco",
    "insert": "Inserisci Disco",
    "writeProtected": "Protetto da Scrittura",
    "readWrite": "Lettura/Scrittura",
    "empty": "Vuoto",
    "loading": "Caricamento...",
    "selectDisk": "Seleziona Immagine Disco",
    "browse": "Sfoglia",
    "newReleases": "Nuove Uscite",
    "writeProtectDisk": "Protezione Scrittura Disco",
    "saveDiskToDevice": "Salva Disco",
    "saveDiskTo": "Salva Disco su",
    "saveDiskToMenu": "Salva Disco su >",
    "addToFavorites": "Aggiungi ai Preferiti",
    "downloadDisk": "Scarica Disco",
    "downloadWoz": "Scarica immagine disco WOZ",
    "downloadAndEjectDisk": "Scarica ed Espelli Disco",
    "ejectDisk": "Espelli Disco",
    "ejectAllDisks": "Espelli tutti i dischi",
    "saveDiskToOneDrive": "Salva Disco su OneDrive",
    "saveDiskToGoogleDrive": "Salva Disco su Google Drive",
    "loadDisk": "Carica disco",
    "loadAdditionalDisks": "Carica disco aggiuntivo...",
    "loadDiskFrom": "Carica Disco da",
    "loadDiskFromMenu": "Carica Disco da >",
    "loadDiskFromDevice": "Carica Disco",
    "loadDiskFromDeviceReadOnly": "Carica Disco da Dispositivo (Sola Lettura)",
    "loadDiskFromDeviceReadWrite": "Carica Disco da Dispositivo (Lettura/Scrittura)",
    "loadDiskFromInternetArchive": "Carica Disco da Internet Archive",
    "loadDiskFromOneDrive": "Carica Disco da OneDrive",
    "loadDiskFromGoogleDrive": "Carica Disco da Google Drive",
    "insertBlankDisk": "Inserisci disco vuoto",
    "syncEveryMinute": "Sincronizza Ogni Minuto",
    "syncEvery5Minutes": "Sincronizza Ogni 5 Minuti",
    "pauseSyncing": "Sospendi Sincronizzazione",
    "syncNow": "Sincronizza Ora",
    "modified": "modificato",
    "synced": "sincronizzato",
    "diskImage": "Immagine Disco",
    "diskDrivesAndDevices": "unità disco e dispositivi",
    "syncedAt": "Sincronizzato {{date}}",
    "clickToLoadDiskImage": "Fare clic per caricare l'immagine (o le immagini) del disco",
    "clickToRemoveFromDiskCollection": "Fare clic per rimuovere dalla raccolta di dischi",
    "clickToAddToDiskCollection": "Fare clic per aggiungere alla raccolta di dischi",
    "byCreator": "da {{creator}}",
    "clickToViewDetails": "Fare clic per visualizzare i dettagli",
    "standbyDisks": "Dischi di riserva (Fai clic per cambiare disco)"
  },
  "help": {
    "title": "Apple2TS",
    "subtitle": "Emulatore Apple IIe in TypeScript",
    "credit": "(c) {{year}} Chris Torrence e i collaboratori di Apple2TS",
    "keyboardShortcuts": "Scorciatoie Tastiera",
    "shortcutsUnavailable": "Le scorciatoie dell'emulatore con {{keyMod}} non sono disponibili mentre questo tasto è assegnato a Open Apple. Con Ctrl+0 fino a Ctrl+5 è comunque possibile selezionare la velocità dell'emulatore.",
    "diskImages": "Immagini disco:",
    "diskContainers": "Archivi compressi:",
    "multiDiskNotice": "Scambio multi-disco: Fare clic sul badge multi-disco per aprire il menu di scambio rapido. Gli archivi multi-disco (.zip, .7z, .gz) caricano automaticamente tutti i dischi nell'elenco.",
    "urlParameters": "Parametri URL Opzionali",
    "examples": "Esempi",
    "mobileInstructions": "Piattaforme mobili:",
    "tapScreen": "Tocca lo schermo per mostrare la tastiera.",
    "arrowKeys": "Premi i tasti freccia, esc, o tab per inviare quei tasti all'emulatore.",
    "ctrlKey": "Per inviare un carattere di controllo, premi il pulsante ctrl una volta. Poi tocca lo schermo per mostrare la tastiera e premi il tasto desiderato. Il pulsante ctrl sarà automaticamente rilasciato.",
    "ctrlLock": "Per inviare più caratteri di controllo, premi il pulsante ctrl due volte per bloccarlo (indicato da un punto verde). Poi tocca lo schermo per mostrare la tastiera e premi i tasti desiderati. Premi il pulsante ctrl di nuovo per rilasciarlo.",
    "appleKeys": "I tasti open apple e closed apple si comportano come il tasto ctrl.",
    "openAppleKey": "Open Apple: premi Alt/Opzione Sin",
    "closedAppleKey": "Closed Apple: premi Alt/Opzione Des",
    "joystickKeys": "Tasti Joystick: Tastierino 8/2/4/6 (7/9/1/3), 0/5, ./Invio",
    "onScreenKeyboard": "Per la tastiera su schermo, per CTRL o ESC:\ntoccare una volta per attivare poi la lettera desiderata.",
    "urlParametersBody": "Per i parametri URL opzionali, aggiungerli all'URL dopo un punto interrogativo (?) e separare più parametri con una e commerciale (&). Usare # per specificare l'immagine disco. Consultare la finestra di dialogo Link Builder per esempi.",
    "exampleLinks": {
      "totalReplayDebugging": "Total Replay con debug",
      "totalReplayChoplifter": "Total Replay, carica Choplifter, modalità integrata",
      "a2Desktop": "A2DeskTop 2MG con velocità alta e colore",
      "embeddedBasic": "Programma Applesoft BASIC Integrato",
      "binaryHexAddress": "File binario con indirizzo esadecimale"
    },
    "links": "Link",
    "resourceLinks": {
      "desktopApp": "App desktop Apple2TS",
      "corsProxy": "Proxy CORS di Corsfix",
      "silverCjkFont": "Silver CJK Pixel Font"
    }
  },
  "messages": {
    "loading": "Caricamento...",
    "error": "Errore",
    "success": "Successo",
    "confirm": "Conferma",
    "cancel": "Annulla",
    "on": "acceso",
    "off": "spento",
    "confirmTheme": "Ricaricare l'emulatore e applicare questo tema ora?",
    "confirmReset": "Ripristinare tutte le impostazioni ai valori predefiniti?",
    "fileNotFound": "File non trovato",
    "invalidFile": "Formato file non valido",
    "diskInserted": "Disco inserito",
    "diskEjected": "Disco espulso"
  },
  "keyboard": {
    "capsLock": "Blocco Maiuscole",
    "shift": "Maiusc",
    "enter": "Invio",
    "space": "Spazio",
    "delete": "Elimina",
    "return": "Invio"
  },
  "audio": {
    "speaker": "Altoparlante",
    "midi": "MIDI",
    "configuration": "Configurazione audio",
    "mute": "Silenzioso",
    "waveform": "Forma d'Onda"
  },
  "print": {
    "printer": "Stampante",
    "print": "Stampa",
    "clear": "Cancella",
    "save": "Salva Output",
    "dumpScreen": "Invia schermata corrente alla stampante",
    "dumpScreenInverse": "Invia schermata corrente (Inversa)",
    "sendToPrinter": "Invia alla stampante",
    "tearOff": "Strappa pagina e reimposta",
    "printedPage": "Pagina stampata",
    "printerConfig": "Configurazione stampante",
    "pageLength": "Lunghezza pagina",
    "pageLengthLetter": "11 pollici (Letter)",
    "pageLengthA4": "11,7 pollici (A4)",
    "pageLengthTwelve": "12 pollici"
  },
  "device": {
    "machineConfiguration": "Configurazione Macchina",
    "midiDeviceSelect": "Selezione Dispositivo MIDI",
    "serialPortSelect": "Selezione Porta Seriale",
    "mockingboardWaveform": "Forma d'Onda Mockingboard"
  },
  "collection": {
    "showApple2TSCollection": "Mostra Collezione Apple2TS",
    "showNewReleases": "Mostra nuove uscite",
    "showFavorites": "Mostra preferiti",
    "chooseDiskImage": "Scegli immagine disco",
    "diskCollection": "Collezione dischi",
    "clickToShowDetails": "Clicca per mostrare dettagli di",
    "clickToLoadDisk": "Clicca per caricare disco",
    "diskIsNewRelease": "Il disco è una nuova uscita",
    "diskIsApple2TSCollection": "Il disco fa parte della collezione Apple2TS",
    "diskIsInternetArchive": "Il disco fa parte di Internet Archive",
    "clickToRemoveFromCollection": "Clicca per rimuovere dalla collezione di dischi",
    "clickToAddToCollection": "Clicca per aggiungere alla collezione di dischi",
    "diskIsSyncedVia": "Disco sincronizzato tramite",
    "loadDiskIntoDrive": "Carica Disco nell'Unità",
    "exportDisksToHdv": "Esporta dischi in HDV",
    "export": "Esporta",
    "clickToRemoveFromSelected": "Clic per rimuovere dai dischi selezionati",
    "clickToAddToSelected": "Clic per aggiungere ai dischi selezionati",
    "reportExportIssue": "Segnala un problema di esportazione"
  },
  "debugControls": {
    "goBackInTime": "Riavvolgi",
    "takeSnapshot": "Cattura Istantanea",
    "goForwardInTime": "Vai Avanti nel Tempo",
    "saveStateWithSnapshots": "Salva Stato con Istantanee",
    "resume": "Riprendi",
    "pause": "Pausa",
    "trace": "Traccia",
    "tracing": "Tracciamento",
    "downloadTraceLog": "Scarica registro traccia"
  },
  "fullscreen": {
    "fullScreen": "Schermo Intero"
  },
  "internetArchive": {
    "searchPlaceholder": "Digita il nome di un software o clicca su una delle categorie sopra",
    "go": "VAI"
  },
  "basic": {
    "newProgram": "Nuovo programma",
    "runFromBeginning": "Esegui dall'inizio",
    "break": "Interrompi",
    "continueRunning": "Continua esecuzione",
    "stepProgram": "Esegui il programme passo-passo",
    "resumeOutput": "Riprendi output",
    "freezeOutput": "Blocca output",
    "importProgram": "Importa programma...",
    "exportProgram": "Esporta programma...",
    "renumberProgram": "Rinumera programma",
    "rebuildProgram": "Ricostruisci programma dalla memoria",
    "displaySettings": "Impostazioni di visualizzazione",
    "autoLineNumbering": "Numerazione automatica delle righe",
    "capitalizeKeywords": "Iniziali in maiuscolo per le parole chiave",
    "rebuildWarning": "Questo sostituirà il programma corrente con una versione ricostruita dalla memoria dell'Apple II. Perderai eventuali modifiche non salvate. Sei sicuro?",
    "variable": "Variabile",
    "value": "Valore"
  },
  "expectin": {
    "runScript": "Esegui script",
    "stopScript": "Interrompi script"
  },
  "saveDisassembly": {
    "title": "Salva disassemblaggio",
    "startAddress": "Indirizzo iniziale $",
    "endAddress": "Indirizzo finale $",
    "includeLabels": "Includi etichette simboli",
    "separatorLines": "Linee separatrici dopo JMP, RTS"
  },
  "gamepad": {
    "useArrowKeys": "Tasti freccia come joystick",
    "siriusJoyport": "Modalità Sirius Joyport"
  },
  "traceSettings": {
    "title": "Impostazioni di tracciamento",
    "settings": "Impostazioni"
  },
  "linkBuilder": {
    "startupOptionsTab": "Opzioni di avvio",
    "speedNames": {
      "warp": "Ridicola"
    },
    "ramDiskSizes": {
      "512": "512",
      "1024": "1024",
      "4096": "4096",
      "8192": "8192"
    },
    "slots": {
      "configure": "Configura schede slot",
      "slot": "Slot {{slot}}:",
      "cardNone": "Nessuna (vuota)"
    },
    "additionalDiskDrives": "Unità disco aggiuntive",
    "slot6Drive1": "Slot 6 Unità 1 (Floppy 1)",
    "slot6Drive2": "Slot 6 Unità 2 (Floppy 2)",
    "slot7Drive1": "Slot 7 Unità 1 (Disco rigido 1)",
    "slot7Drive2": "Slot 7 Unità 2 (Disco rigido 2)",
    "slot2Drive1": "Slot 2 Unità 1 (VERA SD)",
    "slot4Drive1": "Slot 4 Unità 1 (VERA SD)",
    "addAdditionalDisk": "Aggiungi disco aggiuntivo per lo scambio",
    "removeDisk": "Rimuovi questo disco",
    "addAnotherDisk": "Aggiungi un altro disco",
    "diskPlaceholder": "Nome file disco {num} (es. sideB.woz|Disco scenario)"
  },
  "startup": {
    "welcome": "Benvenuto su Apple2TS",
    "subtitle": "Emulatore Apple II in TypeScript",
    "copyright": "(c) {{year}} C.Torrence + collaboratori",
    "diskCollections": "Clicca su Collezione dischi\nper caricare un gioco integrato."
  },
  "retroControl": {
    "machine": "Macchina",
    "fullscreen": "Schermo intero",
    "diskCollection": "Dischi",
    "diskDrives": "Unità disco",
    "display": "Schermo",
    "monitorMode": "Modalità monitor",
    "monitorModeChoice": {
      "ntsc": "NTSC",
      "rgb": "RGB"
    },
    "sound": "Audio",
    "options": "Opzioni",
    "skin": "Aspetto",
    "personalization": "Personalizzazione",
    "text": "Testo",
    "background": "Sfondo",
    "border": "Bordo",
    "iigsColor": {
      "black": "Nero",
      "red": "Rosso",
      "darkBlue": "Blu scuro",
      "purple": "Viola",
      "darkGreen": "Verde scuro",
      "darkGray": "Grigio scuro",
      "mediumBlue": "Blu medio",
      "lightBlue": "Azzurro",
      "brown": "Marrone",
      "orange": "Arancione",
      "lightGray": "Grigio chiaro",
      "pink": "Rosa",
      "lightGreen": "Verde chiaro",
      "yellow": "Giallo",
      "aquamarine": "Acquamarina",
      "white": "Bianco"
    },
    "keyboard": "Tastiera",
    "joystick": "Joystick",
    "slots": "Slot",
    "devices": "Dispositivi",
    "printerPort": "Porta stampante",
    "modemPort": "Porta modem",
    "quit": "Esci",
    "apple2tsCollection": "Raccolta Apple2TS",
    "newReleases": "Nuove uscite",
    "favorites": "Preferiti",
    "exportDisksToHdv": "Esporta dischi in HDV",
    "noDiskDrivesAvailable": "Nessuna unità disco disponibile",
    "select": "Seleziona",
    "open": "Apri",
    "load": "Carica",
    "go": "Vai",
    "save": "Salva",
    "clipboard": "Appunti",
    "cancelEsc": "Annulla:Esc",
    "color": "Colore",
    "systemSpeed": "Velocità del sistema",
    "other": "Altro",
    "timeMachine": "Istantanee",
    "ports": "Porte",
    "language": "Lingua",
    "retroTheme": "Retrò",
    "lowercaseInput": "Inserimento minuscolo",
    "openAppleKey": "Tasto Mela aperta",
    "sortOrder": "Ordina",
    "card": {
      "empty": "Vuoto",
      "mockingboard": "Mockingboard"
    }
  }
}
